export default {
    ABORTO_ESPONTANEO: 'W82',
    ABORTO_PROVOCADO: 'W83',
    DIABETES_GESTACIONAL: 'W85',
    GRAVIDEZ: 'W78',
    GRAVIDEZ_DE_ALTO_RISCO: 'W84',
    GRAVIDEZ_ECTOPICA: 'W80',
    GRAVIDEZ_NAO_DESEJADA: 'W79',
    INFECCOES_QUE_COMPLICAM_A_GRAVIDEZ: 'W71',
    MEDICINA_PREVENTIVA_MANUTENCAO_DA_SAUDE: 'A98',
    PARTO_COM_COMPLICACOES_DE_NASCIDO_VIVO: 'W92',
    PARTO_COM_COMPLICACOES_DE_NATIMORTO: 'W93',
    PARTO_SEM_COMPLICACOES_DE_NASCIDO_VIVO: 'W90',
    PARTO_SEM_COMPLICACOES_DE_NATIMORTO: 'W91',
    TOXEMIA_GRAVIDICA_DHEG: 'W81',
}